import { HeaderProps } from './Header';

/**
 * If the headerData is not null and the component property is equal to 'header', then return true,
 * otherwise return false.
 * @param {any} headerData - any - this is the data that we're checking to see if it's a header
 */
export const isHeaderType = (headerData: any): headerData is HeaderProps =>
  headerData !== null && headerData.component === 'header';
